import React from 'react';

import {
  authService,
  useLoading
} from 'modules';

import { useAuthWrapperLazyQuery } from 'generated/graphql';
import moment from 'moment';



export type IAppAuthStatus = 'requiresUserType' | 'requiresProfileInformation' | 'requiresPaymentInformation' | 'onboarded' | 'isSuperAdmin';




export function useAuthWrapper() {
  const [fnRunQuery, queryTuple] = useAuthWrapperLazyQuery({ fetchPolicy: 'network-only' });
  const [authStatus, setAuthStatus] = React.useState<authService.IStatus>('noAttemptMade');
  const [appAuthStatus, setAppAuthStatus] = React.useState<IAppAuthStatus | null>(null);
  const loading = useLoading([queryTuple]);



  function processAppAuthStatus(status: IAppAuthStatus | null) {
    setAppAuthStatus(status);
  }



  React.useEffect(() => {
    const sub = authService
      .getAuthStateObservable()
      .subscribe(async authState => {
        setAuthStatus(authState.status);
        if (authState.status === 'loggedIn') {
          try {
            const result = await fnRunQuery({});
            const allAccessEnabled = result.data?.allAccessEnabled ?? false;
            const accessPass = result.data?.loggedInUser?.activeAccessPass;
            const hasActiveAccessPass = accessPass && moment(accessPass.startDate).isBefore(moment()) && moment(accessPass.endDate).isAfter(moment());

            if (result.data?.loggedInUser?.isSuperAdmin) {
              processAppAuthStatus('isSuperAdmin');

            } else if (!result.data?.loggedInUser?.type) {
              processAppAuthStatus('requiresUserType');

            } else if (allAccessEnabled) {
              processAppAuthStatus('onboarded');

            } else if (!result.data.loggedInUser.companyProfile) {
              processAppAuthStatus('requiresProfileInformation');

            } else if (hasActiveAccessPass) {
              processAppAuthStatus('onboarded');
              //  A subscription can be incomplete. This is the case when we have not received a response from the Stripe webhook stating that payment has succeeded.

            } else if (result.data.loggedInUser.subscriptionStatus !== 'success' && result.data.loggedInUser.subscriptionStatus !== 'incomplete') {
              processAppAuthStatus('requiresPaymentInformation');

            } else {
              processAppAuthStatus('onboarded');
            }

          } catch (e) {
            console.error(e);
          }
        }
      });

    return () => sub.unsubscribe();
  }, [appAuthStatus, fnRunQuery]);



  return {
    loading,
    data: {
      authStatus,
      appAuthStatus
    }
  };
}
